export default "__VITE_ASSET__c0033403__"